module.exports = __webpack_public_path__ + "static/media/Karla-Italic.740dfd33.ttf";